import { InvoiceStatus } from '../enums/invoiceStatus'
import { Invoice } from '../types/invoices/invoice'

export const getInvoiceDisplayStatus = (
  invoice: Pick<Invoice, 'referredCreditnoteId' | 'summary' | 'status'>,
  creditNoteGrossTotal?: number,
): InvoiceStatus | undefined => {
  if (!invoice.referredCreditnoteId) {
    return invoice.status?.status
  }

  if (creditNoteGrossTotal === undefined) {
    return InvoiceStatus.Credited
  }

  return Math.abs(creditNoteGrossTotal) < invoice.summary.foreignGrossTotal
    ? InvoiceStatus.PartiallyCredited
    : InvoiceStatus.Credited
}
